import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Button,
  VStack,
  HStack,
  Text,
  Textarea,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Badge,
  Spinner,
  Tooltip,
  useToast,
  Icon,
  useClipboard,
  Code
} from '@chakra-ui/react';
import { CopyIcon, RepeatIcon } from '@chakra-ui/icons';
import { v4 as uuidv4 } from "uuid";

// Array di parole chiave SQL per l'highlighting
const SQL_KEYWORDS = [
  // Parole chiave SQL comuni
  'SELECT', 'FROM', 'WHERE', 'INSERT', 'UPDATE', 'DELETE', 'JOIN', 'INNER JOIN', 'LEFT JOIN', 'RIGHT JOIN',
  'GROUP BY', 'ORDER BY', 'HAVING', 'COUNT', 'SUM', 'AVG', 'MAX', 'MIN', 'DISTINCT', 'UNION',
  'CREATE', 'DROP', 'ALTER', 'TABLE', 'DATABASE', 'INDEX', 'VIEW', 'PROCEDURE', 'FUNCTION'
];

// Frasi di autocompletamento predefinite
const AUTOCOMPLETE_SUGGESTIONS = [
  
];

// Componente per la textarea con highlighting e autocompletamento
function HighlightedTextarea({ 
  fetchCatalog, fetchColumns,
  value, 
  onChange, 
  placeholder, 
  keywords = SQL_KEYWORDS,
  
  ...props 
}) {
  const textareaRef = useRef(null);
  const [highlightedText, setHighlightedText] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);

  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1);

  // Funzione per creare il testo con highlighting
  const createHighlightedText = (text) => {
    if (!text.trim()) return '';
    
    const sortedKeywords = [...keywords].sort((a, b) => b.length - a.length);
    let result = text;
    
    sortedKeywords.forEach(keyword => {
      const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp('\\b' + escapedKeyword + '\\b', 'gi');
      result = result.replace(regex, '<mark>$&</mark>');
    });
    
    return result;
  };

useEffect(() => {
  // Questo viene chiamato una sola volta al montaggio
  fetchCatalog().then(res => {
    if (res != null && res.length > 0) {
      let catalogNames = res.map(cat => {
        return {tableName: cat.table_name, tableId: cat.table_id}
      });
      setSuggestions(catalogNames);
    }
  });
}, []);
    
   useEffect(() => {
    
   
    setHighlightedText(createHighlightedText(value));
    
    const filtered = filterSuggestions(value);
    setFilteredSuggestions(filtered);
    setShowSuggestions(filtered.length > 0 && value.trim().length > 2);
    setSelectedSuggestionIndex(-1);
  }, [value, keywords]);

  // Funzione per filtrare i suggerimenti
 const filterSuggestions = (inputValue) => {
  if (!inputValue.trim()) return [];
  
  const words = inputValue.toLowerCase().split(' ');
  const lastWord = words[words.length - 1];
  
  return suggestions.filter(suggestion => {
    const suggestionName = suggestion.tableName.toLowerCase(); // Cambiato da table_name a tableName
    
    const allWordsMatch = words.every(word => 
      word.length > 0 && suggestionName.includes(word)
    );
    
    const lastWordMatch = lastWord.length > 1 && 
      suggestionName.split(' ').some(word => word.startsWith(lastWord));
    
    return allWordsMatch || lastWordMatch;
  }).slice(0, 8);
};

  // Aggiorna il testo evidenziato quando cambia il valore
 

  const handleChange = (e) => {
  
    onChange(e);
  };

  const handleKeyDown = (e) => {
    if (!showSuggestions || filteredSuggestions.length === 0) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedSuggestionIndex(prev => 
          prev < filteredSuggestions.length - 1 ? prev + 1 : 0
        );
        break;
      
      case 'ArrowUp':
        e.preventDefault();
        setSelectedSuggestionIndex(prev => 
          prev > 0 ? prev - 1 : filteredSuggestions.length - 1
        );
        break;
      
      case 'Enter':
        if (selectedSuggestionIndex >= 0) {
          e.preventDefault();
          selectSuggestion(filteredSuggestions[selectedSuggestionIndex]);
        }
        break;
      
      case 'Escape':
        e.preventDefault();
        setShowSuggestions(false);
        setSelectedSuggestionIndex(-1);
        break;
      
      case 'Tab':
        if (selectedSuggestionIndex >= 0) {
          e.preventDefault();
          selectSuggestion(filteredSuggestions[selectedSuggestionIndex]);
        }
        break;
    }
  };

 // NEW - Smart word replacement
const selectSuggestion = (suggestionObj) => {
  const textarea = textareaRef.current;
  const currentValue = textarea.value;
  const currentCursorPos = textarea.selectionStart;
  
  // Find word boundaries
  let wordStart = currentCursorPos;
  let wordEnd = currentCursorPos;
  
  // Move backwards to find word start
  while (wordStart > 0 && /[a-zA-Z0-9_.]/.test(currentValue[wordStart - 1])) {
    wordStart--;
  }
  
  // Move forwards to find word end
  while (wordEnd < currentValue.length && /[a-zA-Z0-9_.]/.test(currentValue[wordEnd])) {
    wordEnd++;
  }
  
  // Replace only the current word with the tableName
  const beforeWord = currentValue.substring(0, wordStart);
  const afterWord = currentValue.substring(wordEnd);
  const newValue = beforeWord + suggestionObj.tableName + afterWord;
  
  // Update with proper cursor positioning
  onChange({ 
    target: { 
      value: newValue, 
      selectionStart: wordStart + suggestionObj.tableName.length 
    } 
  });

  if(!suggestionObj.notProcess) {
 fetchColumns(suggestionObj.tableId).then(res => {
    console.log(res)
    let columns = res.tableInfo.map(column => {

      console.log(column)

        return {tableName: column.columnName, tableId: uuidv4() , notProcess: true}
    });

     setSuggestions(prevSuggestions => [...prevSuggestions, ...columns]);
  })
  }
 
  

  
  // Nascondi i suggerimenti dopo la selezione
  setShowSuggestions(false);
  setSelectedSuggestionIndex(-1);
};
  const handleBlur = () => {
    setTimeout(() => {
      setShowSuggestions(false);
      setSelectedSuggestionIndex(-1);
    }, 150);
  };

  const handleFocus = () => {
    if (value.trim().length > 2 && filteredSuggestions.length > 0) {
      setShowSuggestions(true);
    }
  };

  return (
    <Box position="relative" w="full">
      {/* Div per il background highlighting */}
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        p="8px 12px"
        fontSize="sm"
        fontFamily="inherit"
        lineHeight="1.2"
        whiteSpace="pre-wrap"
        wordWrap="break-word"
        color="transparent"
        bg="transparent"
        border="1px solid transparent"
        borderRadius="lg"
        overflow="hidden"
        pointerEvents="none"
        zIndex={1}
        dangerouslySetInnerHTML={{ __html: highlightedText }}
        sx={{
          '& mark': {
            background: 'linear-gradient(120deg, #a7f3d0 0%, #6ee7b7 100%)',
            color: 'transparent',
            borderRadius: '3px',
            padding: '1px 2px',
            fontWeight: 'bold'
          }
        }}
      />
      
      {/* Textarea effettiva */}
      <Textarea
        ref={textareaRef}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        onFocus={handleFocus}
        placeholder={placeholder}
        bg="transparent"
        position="relative"
        zIndex={2}
        _focus={{
          borderColor: "green.500",
          boxShadow: "0 0 0 1px #38A169"
        }}
        {...props}
      />

      {/* Dropdown dei suggerimenti */}
      {showSuggestions && filteredSuggestions.length > 0 && (
        <Box
          position="absolute"
          top="100%"
          left="0"
          right="0"
          zIndex={1000}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          boxShadow="lg"
          maxH="200px"
          overflowY="auto"
          mt={1}
        >
 {filteredSuggestions.map((suggestion, index) => (
  <Box
    key={suggestion.tableId} // Usa tableId come key
    p={3}
    cursor="pointer"
    bg={selectedSuggestionIndex === index ? "green.50" : "white"}
    borderLeft={selectedSuggestionIndex === index ? "3px solid" : "3px solid transparent"}
    borderLeftColor={selectedSuggestionIndex === index ? "green.500" : "transparent"}
    _hover={{
      bg: "green.50",
      borderLeftColor: "green.300"
    }}
    onClick={() => selectSuggestion(suggestion)}
    transition="all 0.1s"
  >
    <HStack spacing={2}>
      <Icon viewBox="0 0 24 24" boxSize={3} color="green.500">
        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" fill="currentColor"/>
      </Icon>
      <Text fontSize="sm" color="gray.700">
        {suggestion.tableName} {/* Cambiato da table_name a tableName */}
      </Text>
    </HStack>
  </Box>
))}
          
          {/* Footer del dropdown */}
          <Box
            p={2}
            bg="gray.50"
            borderTop="1px solid"
            borderTopColor="gray.100"
          >
            <HStack justify="space-between">
              <Text fontSize="xs" color="gray.500">
                {filteredSuggestions.length} suggerimenti
              </Text>
              <HStack spacing={2}>
                <Text fontSize="xs" color="gray.400">
                  ↑↓ naviga
                </Text>
                <Text fontSize="xs" color="gray.400">
                  Enter seleziona
                </Text>
                <Text fontSize="xs" color="gray.400">
                  Esc chiudi
                </Text>
              </HStack>
            </HStack>
          </Box>
        </Box>
      )}
    </Box>
  );
}

// Badge per mostrare le keywords riconosciute
function KeywordsBadges({ text, keywords = SQL_KEYWORDS }) {
  const recognizedKeywords = keywords.filter(keyword => {
    const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp('\\b' + escapedKeyword + '\\b', 'gi');
    return regex.test(text);
  });

  if (recognizedKeywords.length === 0) return null;

  return (
    <VStack align="start" spacing={2}>
      <Text fontSize="xs" color="gray.600" fontWeight="medium">
        Parole chiave riconosciute:
      </Text>
      <HStack spacing={1} flexWrap="wrap">
        {recognizedKeywords.slice(0, 8).map((keyword, index) => (
          <Badge
            key={index}
            colorScheme="green"
            variant="subtle"
            fontSize="xs"
            px={2}
            py={1}
            borderRadius="full"
          >
            {keyword.toLowerCase()}
          </Badge>
        ))}
        {recognizedKeywords.length > 8 && (
          <Badge
            colorScheme="gray"
            variant="subtle"
            fontSize="xs"
            px={2}
            py={1}
            borderRadius="full"
          >
            +{recognizedKeywords.length - 8}
          </Badge>
        )}
      </HStack>
    </VStack>
  );
}

// Componente per il bottone copia nella descrizione
function CopyDescriptionButton({ description }) {
  const { hasCopied, onCopy } = useClipboard(description);

  return (
    <Tooltip label={hasCopied ? "Copiato!" : "Copia descrizione"} placement="left">
      <IconButton
        position="absolute"
        top="8px"
        right="8px"
        size="sm"
        variant="ghost"
        icon={<CopyIcon />}
        onClick={onCopy}
        aria-label="Copia descrizione"
        colorScheme={hasCopied ? "green" : "gray"}
        bg={hasCopied ? "green.50" : "white"}
        _hover={{
          bg: hasCopied ? "green.100" : "gray.50"
        }}
        zIndex={10}
      />
    </Tooltip>
  );
}

// Funzione per eseguire query SQL
// Funzione per eseguire query SQL tramite API con Axios


function SQLQueryResult({ sql, description, onEdit, onExecute, onRemove, isEditing, editedSQL, setEditedSQL }) {
  const { hasCopied, onCopy: copyToClipboard } = useClipboard(isEditing ? editedSQL : sql);
  const [isExecuting, setIsExecuting] = useState(false);
  const toast = useToast();

  const handleExecute = async () => {
    setIsExecuting(true);
    try {
      const queryToExecute = isEditing ? editedSQL : sql;
      await onExecute(queryToExecute);
    } catch (error) {
      toast({
        title: "Errore nell'esecuzione",
        description: "Si è verificato un errore durante l'esecuzione della query",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsExecuting(false);
    }
  };

  const handleRemove = () => {
    onRemove();
    toast({
      title: "Query rimossa",
      description: "La query è stata eliminata dalla cronologia",
      status: "info",
      duration: 2000,
      isClosable: true,
    });
  };

  return (
    <Box
      bg="gray.50"
      borderRadius="lg"
      p={4}
      border="1px solid"
      borderColor="gray.200"
      mb={4}
    >
      {/* Header */}
      <HStack justify="space-between" align="center" mb={3}>
        <HStack spacing={2}>
          <Icon viewBox="0 0 24 24" boxSize={4} color="green.500">
            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" fill="currentColor"/>
          </Icon>
          <Text fontSize="sm" fontWeight="medium" color="gray.700">
            Query SQL Generata dall'AI
          </Text>
        </HStack>
        
        <HStack spacing={2}>
          <Tooltip 
            label={isEditing ? "Blocca modifica" : "Sblocca per modificare"} 
            placement="left"
          >
            <IconButton
              size="sm"
              variant={isEditing ? "solid" : "outline"}
              colorScheme={isEditing ? "green" : "gray"}
              icon={
                <Icon viewBox="0 0 24 24" boxSize={3}>
                  {isEditing ? (
                    <path d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  ) : (
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  )}
                </Icon>
              }
              onClick={onEdit}
              aria-label={isEditing ? "Blocca modifica" : "Modifica query"}
            />
          </Tooltip>
          
          <Tooltip label="Rimuovi questa query" placement="left">
            <IconButton
              size="sm"
              variant="ghost"
              colorScheme="red"
              icon={
                <Icon viewBox="0 0 24 24" boxSize={3}>
                  <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2"/>
                </Icon>
              }
              onClick={handleRemove}
              aria-label="Rimuovi query"
              _hover={{ bg: "red.50" }}
            />
          </Tooltip>
        </HStack>
      </HStack>

      {/* Descrizione originale */}
      <Box mb={3}>
        <Text fontSize="xs" fontWeight="medium" color="gray.600" mb={1}>
          Richiesta:
        </Text>
        <Text fontSize="sm" color="gray.700" fontStyle="italic">
          "{description}"
        </Text>
      </Box>

      {/* SQL Query */}
      <Box
        bg="white"
        borderRadius="md"
        p={4}
        border="1px solid"
        borderColor="gray.100"
        mb={3}
        minH="120px"
        position="relative"
      >
        {isEditing ? (
          <Textarea
            value={editedSQL}
            onChange={(e) => setEditedSQL(e.target.value)}
            fontFamily="mono"
            fontSize="sm"
            resize="vertical"
            minH="120px"
            border="none"
            _focus={{ boxShadow: "none" }}
          />
        ) : (
          <Code
            display="block"
            whiteSpace="pre-wrap"
            fontSize="sm"
            bg="transparent"
            p={0}
            fontFamily="mono"
            lineHeight="1.5"
          >
            {sql}
          </Code>
        )}
      </Box>

      {/* Actions */}
      <HStack justify="space-between" align="center">
        <HStack spacing={1}>
          <Icon viewBox="0 0 24 24" boxSize={3} color="gray.400">
            <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" stroke="currentColor" strokeWidth="2" fill="none"/>
          </Icon>
          <Text fontSize="xs" color="gray.500">
            Powered by AI
          </Text>
        </HStack>
        
        <HStack spacing={2}>
          <Button
            size="sm"
            variant="outline"
            leftIcon={<CopyIcon />}
            onClick={copyToClipboard}
            colorScheme={hasCopied ? "green" : "gray"}
          >
            {hasCopied ? "Copiato!" : "Copia"}
          </Button>
          
          <Button
            size="sm"
            colorScheme="blue"
            leftIcon={
              <Icon viewBox="0 0 24 24" boxSize={3}>
                <path d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" fill="none"/>
              </Icon>
            }
            onClick={handleExecute}
            isLoading={isExecuting}
            loadingText="Eseguendo..."
            isDisabled={!sql.trim()}
          >
            Esegui
          </Button>
        </HStack>
      </HStack>
    </Box>
  );
}

function LoadingState() {
  return (
    <Box
      bg="white"
      borderRadius="lg"
      p={6}
      border="1px solid"
      borderColor="gray.200"
      textAlign="center"
    >
      <VStack spacing={3}>
        <Spinner size="md" color="green.500" />
        <Text fontSize="sm" color="gray.600">
          L'AI sta generando la query SQL...
        </Text>
        <Text fontSize="xs" color="gray.400">
          Puoi chiudere il modal in qualsiasi momento
        </Text>
      </VStack>
    </Box>
  );
}

function AISQLGenerator({text2queryResponse, axiosInstance,fetchCatalog,fetchColumns,executeSQLAIGenerated,handleClickEseguiAISQLGenerator}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [description, setDescription] = useState('');
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editedSQL, setEditedSQL] = useState('');
  const toast = useToast();

  

  const generateSQL = async () => {
    if (!description.trim()) {
      toast({
        title: "Descrizione vuota",
        description: "Inserisci una descrizione per generare la query SQL",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsLoading(true);

    try {
      const res = await text2queryResponse(null,description);
      
      if (res && res.llmResponse) {
        if (editingId) {
          setResults(prev => prev.map(result => 
            result.id === editingId 
              ? { ...result, sql: res.llmResponse, description: description }
              : result
          ));
          setEditedSQL(res.llmResponse);
          
          toast({
            title: "Query aggiornata!",
            description: "La query in modifica è stata rigenerata",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        } else {
          const newResult = {
            id: Date.now(),
            description: description,
            sql: res.llmResponse,
            timestamp: new Date()
          };

          setResults(prev => [newResult, ...prev]);
          
          toast({
            title: "Query generata con successo!",
            description: "La query SQL è pronta per essere utilizzata",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        }
        
        setDescription('');
      } else {
        throw new Error('Nessuna risposta dall\'AI');
      }
    } catch (error) {
      toast({
        title: "Errore di generazione",
        description: "Impossibile generare la query SQL. Riprova.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error('Errore generazione SQL:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExecuteQuery = async (sqlQuery) => {
    try {
      const result = await executeSQLAIGenerated(axiosInstance,sqlQuery, 1, toast);
      handleClickEseguiAISQLGenerator(result.data)
      return result;
    } catch (error) {
      console.error('Errore esecuzione query:', error);
      throw error;
    }
  };

  const handleEdit = (id, sql) => {
    if (editingId === id) {
      setResults(prev => prev.map(result => 
        result.id === id 
          ? { ...result, sql: editedSQL }
          : result
      ));
      setEditingId(null);
      setEditedSQL('');
      
      toast({
        title: "Modifiche salvate",
        description: "La query è stata aggiornata con le tue modifiche",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } else {
      setEditingId(id);
      setEditedSQL(sql);
    }
  };

  const handleRemoveQuery = (id) => {
    setResults(prev => prev.filter(result => result.id !== id));
    
    if (editingId === id) {
      setEditingId(null);
      setEditedSQL('');
    }
  };

  const clearResults = () => {
    setResults([]);
    setDescription('');
    setEditingId(null);
    setEditedSQL('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      generateSQL();
    }
  };

  return (
    <>
      {/* Floating AI Button */}
      <Tooltip label="AI SQL Query Generator" placement="left">
        <IconButton
          icon={
            <Icon viewBox="0 0 24 24" boxSize={6}>
              <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" stroke="currentColor" strokeWidth="2" fill="none"/>
            </Icon>
          }
          size="lg"
          bg="green.500"
          color="white"
          borderRadius="full"
          position="fixed"
          bottom="20px"
          right="20px"
          zIndex={1000}
          boxShadow="lg"
          onClick={onOpen}
          aria-label="Apri AI SQL Generator"
          _hover={{
            bg: "green.600",
            transform: 'scale(1.05)',
            boxShadow: 'xl'
          }}
          _active={{
            transform: 'scale(0.95)'
          }}
          transition="all 0.2s"
        />
      </Tooltip>

      {/* Modal */}
      <Modal 
        isOpen={isOpen} 
        onClose={onClose} 
        size="4xl" 
        isCentered
        closeOnOverlayClick={true}
        closeOnEsc={true}
      >
        <ModalOverlay bg="blackAlpha.600" />
           <ModalContent 
            maxH="90vh" 
            bg="white"
            borderRadius="2xl"
            boxShadow="2xl"
            overflow="hidden"
            display="flex"
            flexDirection="column"
          >
          <ModalHeader
            bg="green.500"
            color="white"
            borderTopRadius="2xl"
            py={4}
          >
            <HStack spacing={3}>
              <Icon viewBox="0 0 24 24" boxSize={5}>
                <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" stroke="currentColor" strokeWidth="2" fill="none"/>
              </Icon>
              <Text fontSize="lg" fontWeight="bold">
                AI SQL Query Generator
              </Text>
            </HStack>
            <Text fontSize="sm" opacity={0.9} mt={1}>
              Descrivi cosa vuoi fare e l'AI genererà la query SQL
            </Text>
          </ModalHeader>
          
          <ModalCloseButton 
            color="white" 
            _hover={{ bg: "whiteAlpha.200" }}
          />
          
          <ModalBody p={6}>
            <VStack spacing={6} align="stretch">
              {/* Input Section */}
              <VStack spacing={4} align="stretch">
                <Button
                  bg="green.500"
                  color="white"
                  size="lg"
                  borderRadius="full"
                  leftIcon={
                    <Icon viewBox="0 0 24 24" boxSize={4}>
                      <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" stroke="currentColor" strokeWidth="2" fill="none"/>
                    </Icon>
                  }
                  onClick={generateSQL}
                  isLoading={isLoading}
                  loadingText="Generando..."
                  isDisabled={!description.trim()}
                  _hover={{ bg: "green.600" }}
                  _active={{ bg: "green.700" }}
                  spinner={<Spinner size="sm" color="white" />}
                >
                  Genera Query SQL
                </Button>

                <VStack align="start" spacing={3}>
                  <HStack spacing={2}>
                    <Icon viewBox="0 0 24 24" boxSize={4} color="gray.600">
                      <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" stroke="currentColor" strokeWidth="2" fill="none"/>
                    </Icon>
                    <Text fontSize="sm" fontWeight="medium" color="gray.700">
                      Descrivi la query che vuoi in linguaggio naturale
                    </Text>
                  </HStack>
                  
                  <Box position="relative" w="full">
                    <HighlightedTextarea
                    fetchCatalog={fetchCatalog}
                    fetchColumns={fetchColumns}
                      
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Es: Voglio vedere tutti gli utenti registrati negli ultimi 30 giorni con le loro email..."
                      resize="vertical"
                      minH="100px"
                      bg="gray.50"
                      border="1px solid"
                      borderColor="gray.200"
                      borderRadius="lg"
                      onKeyPress={handleKeyPress}
                      isDisabled={isLoading}
                      pr="50px"
                      suggestions={AUTOCOMPLETE_SUGGESTIONS}
                    />
                    
                    {description.trim() && (
                      <CopyDescriptionButton description={description} />
                    )}
                  </Box>
                  
                  {/* Keywords riconosciute */}
                  {description.trim() && (
                    <KeywordsBadges text={description} />
                  )}
                  
                  <HStack justify="space-between" w="full">
                    <Text fontSize="xs" color="gray.500">
                      Scrivi e usa ↑↓ per navigare i suggerimenti
                    </Text>
                    <HStack spacing={2}>
                      <Text fontSize="xs" color="gray.400">
                        {description.length} caratteri
                      </Text>
                      {results.length > 0 && (
                        <Button
                          size="xs"
                          variant="ghost"
                          onClick={clearResults}
                          leftIcon={<RepeatIcon />}
                        >
                          Reset
                        </Button>
                      )}
                    </HStack>
                  </HStack>
                </VStack>
              </VStack>

              {/* Results Section */}
              <Box maxH="500px" overflowY="auto">
                {isLoading && <LoadingState />}
                
                {results.map((result) => (
                  <SQLQueryResult
                    key={result.id}
                    sql={result.sql}
                    description={result.description}
                    onEdit={() => handleEdit(result.id, result.sql)}
                    onExecute={handleExecuteQuery}
                    onRemove={() => handleRemoveQuery(result.id)}
                    isEditing={editingId === result.id}
                    editedSQL={editedSQL}
                    setEditedSQL={setEditedSQL}
                  />
                ))}
                
                {!isLoading && results.length === 0 && (
                  <Box
                    textAlign="center"
                    py={8}
                    color="gray.500"
                  >
                    <VStack spacing={3}>
                      <Icon viewBox="0 0 24 24" boxSize={8} color="gray.300">
                        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 3a4 4 0 100 8 4 4 0 000-8zM16 12l2 2 4-4" stroke="currentColor" strokeWidth="2" fill="none"/>
                      </Icon>
                      <Text fontSize="sm">
                        Descrivi cosa vuoi fare e l'AI genererà la query SQL perfetta per te
                      </Text>
                      
                 
                    </VStack>
                  </Box>
                )}
              </Box>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AISQLGenerator;